import React from 'react'
import styled from '@emotion/styled'
import { textCrop } from '../GlobalStyles/typography'

export interface HeadingProps {
  children?: React.ReactNode

  level: 1 | 2 | 3 | 4
  align?: 'left' | 'right' | 'center'
  truncate?: boolean
  color?: 'string'
}

const resolveDefaultComponent = {
  '1': 'h1',
  '2': 'h2',
  '3': 'h3',
  '4': 'h4'
} as const

export const Heading: React.FC<HeadingProps> = ({
  children,
  level = 1,
  align,
  truncate,
  color
}) => {
  const content = truncate ? <TruncateHeading>{children}</TruncateHeading> : children

  return (
    <StyledHeading as={resolveDefaultComponent[level]} level={level} align={align} color={color}>
      {content}
    </StyledHeading>
  )
}

const TruncateHeading = styled('span')`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const StyledHeading = styled('div')<HeadingProps>`
  ${textCrop()}

  ${(p) =>
    p.align &&
    `
    text-align: ${p.align}
  `}
`
